// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2G4-V","title":"FrontImage_title__1kdiO"};